<template>
  <pt-holiday-excel-new class="pt-holiday-excel-new__page"></pt-holiday-excel-new>
</template>

<script>
import PtHolidayExcelNew from 'cps/lab-order/pt-holiday-manage/pt-holiday-excel-new/withData'
export default {
  name: 'pt-holiday-excel-new__view',
  components: {
    'pt-holiday-excel-new': PtHolidayExcelNew
  }
}
</script>
